import * as api from "../api/groupAPI";
import * as types from "../constants/organisationConstants";

export const fetchGroupsAction = () => async (dispatch) => {
  try {
    const { error, data } = await api.fetchGroups();

    if (error) {
      throw new Error(error);
    }

    dispatch({
      type: types.FETCH_GROUPS,
      payload: data,
    });
  } catch (error) {
    // dispatch({
    //   type: types.GET_USER_FAIL,
    //   payload: error.message,
    // });
  }
};

export const createGroupAction = (groupData) =>async (dispatch) => {
  try {
    const { error, data } = await api.createGroup(groupData);

    if (error) {
      throw new Error(error);
    }

    dispatch({
      type: types.CREATE_GROUP,
      payload: data,
    });
  } catch (error) {
    // dispatch({
    //   type: types.GET_USER_FAIL,
    //   payload: error.message,
    // });
  }
};

export const adjustRewardDistributionAction = (organisationId, groupId, newRewardDistribution) =>async (dispatch) => {
  try {
    const {error, data } = await api.editGroup(organisationId, groupId, newRewardDistribution)

    dispatch({
      type: types.ADJUST_REWARD_DISTRIBUTION,
      payload: {
        groupId, newRewardDistribution
      },
    });
  } catch (error) {
    // dispatch({
    //   type: types.GET_USER_FAIL,
    //   payload: error.message,
    // });
  }
};

export const addMembersAction = (organisationId, groupId, memberIds) =>async (dispatch) => {
  try {
    const {error, data } = await api.addMembers(organisationId, groupId, memberIds)

    dispatch({
      type: types.ADD_MEMBERS_TO_GROUP,
      payload: data,
    });
  } catch (error) {
    // dispatch({
    //   type: types.GET_USER_FAIL,
    //   payload: error.message,
    // });
  }
};

export const deleteGroupAction = (organisationId, groupId) => async (dispatch) => {
  try {
    const { error } = await api.deleteGroup(organisationId, groupId);
    if (error) throw new Error(error);
    dispatch({
      type: types.DELETE_GROUP,
      payload: { groupId },
    });
    return { error: null };
  } catch (error) {
    return { error: error.message || "Delete failed" };
  }
};

export const renameGroupAction = (organisationId, groupId, name) => async (dispatch) => {
  try {
    const { error } = await api.renameGroup(organisationId, groupId, name);
    if (error) throw new Error(error);
    dispatch({
      type: types.EDIT_GROUP,
      payload: { groupId, name },
    });
  } catch (error) {
    // swallow per existing pattern in this file
  }
};

export const removeMembersAction = (organisationId, groupId, memberIds) => async (dispatch) => {
  try {
    const {error, data } = await api.removeMembers(organisationId, groupId, memberIds)

    dispatch({
      type: types.REMOVE_MEMBERS_TO_GROUP,
      payload: data,
    });
  } catch (error) {
    // dispatch({
    //   type: types.GET_USER_FAIL,
    //   payload: error.message,
    // });
  }
};